import api from '../Utils/api'

export const fetchTagsList = async () => {
  const apiResponse = await api('GET', 'tags/all', null)
  return apiResponse
}
